export default "__VITE_ASSET__2ea561da__"